<template>
  <div v-if="params.value != 0">
    <i class="fas fa-circle" :class="{
      'rejected' : (params.value > 0 && params.value < 5) || params.value == 60,
      'revision': params.value == 10 || params.value == 12,
      'reg-approve': params.value == 16 || params.value == 18,
      'filled': params.value == 20,
      'plan-approve': params.value == 22,
      'finished': params.value == 50 }"></i>
    {{ pdrStatus }}
  </div>
</template>

<script>
export default {
  name: 'atStatusRenderer',
  computed: {
    pdrStatus () {
      return this.$lang.PCI.AT['Status' + this.params.value]
    }
  }
}
</script>

<style scoped>
  .fas {
    font-size: 15px;
    text-shadow: -1px 1px 2px #615e5e;
  }

  .revision {
    color: rgb(164, 59, 185);
  }
  .filled {
    color: white;
  }
  .plan-approve {
    color: yellow;
  }
  .reg-approve {
    color: #fbc259;
  }
  .finished {
    color: #0eff8d;
  }
  .rejected {
    color: #ff2700;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/AtStatusRenderer.vue